import React from 'react';
import PropTypes from 'prop-types'


class Loader extends React.Component {
  render() {
    return (
      <div className="busLoader">
      <div className="loaderDialog" style={{ background: 'transparent' }}>
        <div className="imageContainer">
            <div className="loader-wrp">
              <svg className="circular-icon" viewBox="25 25 50 50">
                <circle
                  className="circle-path"
                  cx="50"
                  cy="50"
                  r="20"
                  fill="none"
                  strokeWidth="3"
                  strokeMiterlimit="10"
                />
              </svg>
            </div>
        </div>
      </div>
    </div>
    );
  }

}

Loader.propTypes = {
  title: PropTypes.string,
  onPaxChange: PropTypes.func,
  currentInfo: PropTypes.object,
};

export default Loader;
